'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCrop75 = function ImageCrop75(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z' })
  );
};
ImageCrop75 = (0, _pure2.default)(ImageCrop75);
ImageCrop75.displayName = 'ImageCrop75';

exports.default = ImageCrop75;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/crop-7-5.js
 ** module id = 1578
 ** module chunks = 0
 **/